<template>
    <v-container
      class="py-0"
      fluid>
        <v-row
            align="center"
            justify="center"
            class="job-links"
        >
            <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                class="pa-1"
            >
                <v-card
                :to="{ name:'Job', params:{id:id, tab: 0} }"
                >
                    <v-list-item two-line class="green">
                        <v-list-item-content class="py-0">
                            <v-row
                                align="center"
                                justify="center"
                                class="job-links"
                            >
                                <v-col
                                    cols="6"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    class="px-2"
                                >
                                    <v-list-item-title class="white--text">
                                    Job #
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="title font-weight-bold white--text">{{ ('0' + id).slice(-6) }}</v-list-item-subtitle>
                                </v-col>
                                <v-col
                                    cols="6"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    class="text-right px-2"
                                >
                                    <v-list-item-title class="white--text">
                                    Customer
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="title font-weight-bold white--text">{{ form.customer.object.first_name + ' ' + form.customer.object.last_name }}</v-list-item-subtitle>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>

                    <v-card-text class="text-center py-12">
                        <h2 class="text-uppercase green--text">Contract & Customer</h2>
                        <v-chip
                        class="ma-2 text-uppercase font-weight-bold"
                        color="green"
                        text-color="white"
                        label
                        >
                            {{ form.status | separate }}
                        </v-chip>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                
            >
                <v-card
                    light
                    :to="{ name:'Job', params:{id:id, tab: 1} }"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Pool Details</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                
            >
                <v-card
                    light
                    :to="{ name:'Job', params:{id:id, tab: 2} }"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Assignees</span>
                        <v-spacer></v-spacer>
                        <v-list class="pa-0">
                            <v-list-item class="secondary stat px-1"
                            >
                                <v-list-item-content class="text-center">
                                    <v-list-item-title class="caption text-uppercase white--text">Assignees - 5</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                
            >
                <v-card
                    light
                    :to="{ name:'Job', params:{id:id, tab: 3} }"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Images/Media</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                
            >
                <v-card
                    light
                    :to="{ name:'Job', params:{id:id, tab: 4} }"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Notes</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                
            >
                <v-card
                    light
                    :to="{ name:'Job', params:{id:id, tab: 5} }"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Equipment</span>
                        <v-spacer></v-spacer>
                        <v-list class="pa-0">
                            <v-list-item class="secondary stat px-1"
                            >
                                <v-list-item-content class="text-center">
                                    <v-list-item-title class="caption text-uppercase white--text">Active - 5</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
            >
                <v-card
                    light
                    :to="{ name:'Job', params:{id:id, tab: 6} }"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Warranty</span>    
                        <v-spacer></v-spacer>
                        <v-list class="pa-0">
                            <v-list-item class="secondary stat px-1"
                            >
                                <v-list-item-content class="text-center">
                                    <v-list-item-title class="caption text-uppercase white--text">Active - 5</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>              
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
            >
                <v-card
                    light
                    :to="{ name:'Job', params:{id:id, tab: 7} }"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Issue Tracker</span>
                        <v-spacer></v-spacer>
                        <v-list class="pa-0">
                            <v-list-item class="secondary stat px-1"
                            >
                                <v-list-item-content class="text-center">
                                    <v-list-item-title class="caption text-uppercase white--text">Active - 5</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>   
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
            >
                <v-card
                    light
                    outlined
                    :to="{ name:'Job', params:{id:id, tab: 8} }"
                    color="#1565c0"
                >
                    <v-card-title class="py-2">                             
                        <span class="title text-uppercase font-weight-bold white--text">Punch List</span>
                        <v-spacer></v-spacer>
                        <v-list class="pa-0">
                            <v-list-item class="secondary stat px-1"
                            >
                                <v-list-item-content class="text-center">
                                    <v-list-item-title class="caption text-uppercase white--text">Active - 5</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>   
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'

    export default {
        props: ['id'],
        data: () => ({
            form: {
                customer: {
                    label: '',
                    value: '',
                    object: []
                },
                status: '',
                date: new Date().toISOString().substr(0, 10),
                amount: '',
                job_type: '',
                size: '',
                pool_type: '',
                users: {
                    admin: '',
                    foreman: '',
                    salesperson: '',
                    technician: '',
                    cleaner: ''
                },
                pooloptions: [],
                liner_color: '',
                tile_selection: '',
                plaster: '',
                coping: '',
                deck: '',
                deck_color: '',
                border_color: '',
                waterfall_color: '',
                images: [],
                comments: [],          
            },
        }),
        created() {
            this.getJob()
        },
        methods: {
            getJob() {
                if(this.id) {
                    axios.get('crm/jobs/get?id=' + this.id)
                        .then((response) => {
                            this.form = response.data
                            this.$nextTick()
                        })
                }
            },
        }
    }
</script>
<style lang="sass">
.v-content
    background: #003a6f

.job-links
    padding: 4px
    
    .col-sm-12 
        padding: 4px

.v-application 
    .headline
        font-family: 'Pyxel'!important
        font-size: 1.5em!important

    .stat
        min-height: auto
        padding: 7px 12px!important
        border-radius: 3px

        > div 
            padding: 0!important
</style>